<template>
  <div
    v-click-outside="hideChannels"
    class="communication-channels"
  >
    <div
      class="communication-channel-item communication-channel-item--main"
      @click="setStateVisibleChannels(!isVisibleChannel)"
    >
      <div class="communication-channel-item__logo" />
    </div>

    <OperatorCard
      v-if="isVisibleChannel && channelOperator"
      class="communication-channels__message-panel"
      :channel-operator="channelOperator"
      @close="hideChannels"
    />

    <div
      v-if="isVisibleChannel"
      class="component-channel-items"
    >
      <component
        :is="{ ...ComponentsByType[channel.type] }"
        v-for="channel in channels"
        :key="channel.type"
        :settings="channel.settings"
      />
    </div>
  </div>
</template>

<script lang="ts">
import vClickOutside from 'click-outside-vue3';

import {
  PhoneChannel,
  EmailChannel,
  Types as CommunicationChannelTypes,
} from '@/entities/communication-channel';
import {
  OperatorCard,
  type Types as CommunicationChannelOperatorTypes,
} from '@/entities/communication-channel-operator';

const ComponentsByType = {
  [CommunicationChannelTypes.ECommunicationChannelType.phone]: PhoneChannel,
  [CommunicationChannelTypes.ECommunicationChannelType.email]: EmailChannel,
};

export default defineComponent({
  name: 'CommunicationChannels',

  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: {
    OperatorCard,
  },

  props: {
    channels: {
      type: Array as PropType<CommunicationChannelTypes.IBaseCommunicationChannel[]>,
      default: () => [],
    },
    channelOperator: {
      type: Object as PropType<CommunicationChannelOperatorTypes.ICommunicationChannelOperator>,
      default: null,
    },
  },

  data() {
    return {
      isVisibleChannel: false,
      ComponentsByType,
    };
  },

  methods: {
    setStateVisibleChannels(state = false) {
      this.isVisibleChannel = state;
    },

    hideChannels() {
      this.isVisibleChannel = false;
    },
  },
});
</script>

<style lang="scss" scoped>
.communication-channels {
  position: fixed;
  bottom: 66px;
  right: 30px;
  z-index: 10;

  .component-channel-items {
    position: absolute;
    bottom: calc(100% + 25px);
    left: 2px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__message-panel {
    position: absolute;
    left: -276px;
    bottom: 11px;
  }
}
</style>

<style lang="scss">
.communication-channel-item {
  height: 44px;
  width: 44px;
  background-color: #c8c8cc;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  &--main {
    height: 48px;
    width: 48px;
  }

  &__logo {
    background-image: url('./images/question.svg');
    width: 13px;
    height: 21px;
    background-position: center;
  }
}
</style>

<style lang="scss" scoped>
@media (max-width: 767px) {
  .communication-channels {
    bottom: 90px;
  }

  .communication-channel-item {
    &:hover {
      opacity: 1;
    }
  }
}
</style>
